import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { NewBankDetailsComponent } from './new-bank-details.component';

const routes: Routes = [
  { path: '', component: NewBankDetailsComponent, data: { title: 'Bank Account Details' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NewBankDetailsRoutingModule {}

@NgModule({
  imports: [
    NewBankDetailsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [NewBankDetailsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NewBankDetailsModule {}
